import {useScrollToSection} from '@aboutyou/ui-components';
import React from 'react';
import {SCROLL_TO_SIMILAR_ITEMS_PARAM} from './useSimilarItemsScrollManager';

export const ScrollSimilarItemsView: React.FC = () => {
  const {ScrollToTarget} = useScrollToSection(SCROLL_TO_SIMILAR_ITEMS_PARAM);
  return <ScrollToTarget />;
};
